export { default } from './UploadImage'
